import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import CitiesListContainer from './containers/cities-list/cities-list.container';

export const CityModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.CITY_MODULE.FULL_PATH}>
        <Redirect to={(APP_ROUTES.CITY_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
      </Route>
      <Route
        path={(APP_ROUTES.CITY_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
        component={CitiesListContainer}
      />
    </>
  );
};
